import { useContext, useEffect } from 'react';
import AnimateHeight from 'react-animate-height';
import AppliedFiltersContext from '~/context/srp/AppliedFiltersContext';
import { useFacetData } from '~/context/srp/FacetDataContext';
import useCheckExperimentBucket from '~/hooks/srp/useCheckExperimentBucket';
import FilterDrawer from './FilterDrawer';
import useRangeUpdater from './hooks/useRangeUpdater';
import RangeSlider from './RangeSlider';
import useExpand from './useExpand';
import type WithClassName from './WithClassName';

export default function TowingCapacity({ className }: WithClassName) {
  const isInExperiment = useCheckExperimentBucket(
    'srch-impossible-facets2',
    'experiment'
  );
  const { appliedFilters } = useContext(AppliedFiltersContext);
  const [expand, setExpand] = useExpand(false);
  const facetData = useFacetData();

  const show =
    (isInExperiment
      ? facetData.towingCapacity && facetData.towingCapacity?.min > 0
      : appliedFilters.bodyStyles?.includes('Pickup') &&
        facetData.towingCapacity) ?? false;

  useEffect(() => {
    if (!show) setExpand(false);
  }, [setExpand, show]);

  const onUpdate = useRangeUpdater({
    filterKey: 'towingCapacity',
    max: facetData.towingCapacity?.max,
    min: facetData.towingCapacity?.min
  });

  return (
    <AnimateHeight duration={500} height={show ? 'auto' : 0}>
      <FilterDrawer
        className={className}
        dataQa="facet-towing-capacity"
        facetContent
        facetName="Towing Capacity"
        show={expand}
        onToggle={() => setExpand(v => !v)}
      >
        <div className="gap-32 grid px-24 py-32">
          <RangeSlider
            data-analytics-id="adjust-towing-capacity-range"
            format="number"
            isShowing={expand}
            id="facet-towing-capacity"
            label="Tow Capacity"
            dualRange
            min={facetData.towingCapacity?.min}
            max={facetData.towingCapacity?.max}
            initialValues={[
              appliedFilters.towingCapacity?.min ??
                facetData.towingCapacity?.min ??
                0,
              appliedFilters.towingCapacity?.max ??
                facetData.towingCapacity?.max ??
                0
            ]}
            onUpdate={onUpdate}
          />
        </div>
      </FilterDrawer>
    </AnimateHeight>
  );
}
